import { withRouter } from 'react-router'

import { compose, lifecycle, withHandlers, withState } from 'recompose'

import { USER_EMAIL, USER_UUID } from 'app-constants'
import withHeroText from 'components/HOCs/withHeroText'
import withPartnerProps from 'components/HOCs/WithPartnerProps'
import { TRACKER_IDS } from 'components/Trackers/trackerIDs'
import trackEvent from 'utils/analytics/trackEvent'
import { withEnv } from 'utils/environment'
import { withFlowRouter } from 'utils/FlowProvider'
import { withOptimizely } from 'utils/Optimizely'
import withTieredRegistration from 'utils/TieredRegistration'

import { InnerProps } from './types'
import { isFlowDirectToMobile, trackDirectToMobileOptimizelyHandler } from './utils'

export const enhance = compose<InnerProps, {}>(
  withEnv,
  withHeroText,
  withFlowRouter,
  withRouter,
  withPartnerProps,
  withOptimizely,
  withTieredRegistration,
  withHandlers<InnerProps, {}>({
    trackDirectToMobileOptimizely: trackDirectToMobileOptimizelyHandler,
  }),
  withState('loading', 'setLoading', true),
  lifecycle<InnerProps, {}>({
    async componentDidMount() {
      if (!isFlowDirectToMobile() && window.sessionStorage.getItem(USER_UUID)) {
        await this.props.setFlowAndUseUpdateRegMutation('directToMobile')
      }

      // NOTE: The PageViewedAnalytics component in the router will record a screen_viewed event
      // using the visitorId of the user. Calling the method below will send a screen_viewed
      // event with the backend uuid of the user.
      this.props.trackDirectToMobileOptimizely(`${TRACKER_IDS.DIRECT_TO_MOBILE.PAGE}.screen_viewed`)
      trackEvent('Screen Viewed', {
        eventData: {
          object_name: TRACKER_IDS.DIRECT_TO_MOBILE.PAGE,
          screen: TRACKER_IDS.DIRECT_TO_MOBILE.PAGE,
          screen_name: TRACKER_IDS.DIRECT_TO_MOBILE.PAGE,
          email: window.sessionStorage.getItem(USER_EMAIL),
        },
      })
      this.props.setLoading(false)
    },
  }),
)
